import React, { useState, useEffect, Fragment } from "react";
import { Row, Card, CardBody } from "reactstrap"
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import Step1 from "./Step1";
import Instructions from "./Instructions";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import AlertError from "../../../components/Alerts/AlertError";
import { orgId } from "../../../constants/utils";

const CreateEmployee = (props) => {

  const dispatch = useDispatch()
  const [step, setStep] = useState(1);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [company, setCompany] = useState({});
  const [companyId, setCompanyId] = useState(0);
  const [companyName, setCompanyName] = useState("");
  const [id, setId] = useState(null);
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] })
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  useEffect(() => {
    document.title = `${i18n.t("CostCenterEdit")} - ${orgId}`;
  }, [orgId]);

  useEffect(() => {
    getCostCenter()
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [dispatch, data, loading]);

  useEffect(() => {
    infoUser.is_staff ? null : setCompany({ label: infoUser.partner_name, value: infoUser.partner_id })
  }, [infoUser]);

  const getCostCenter = () => {
    let localSelectCostCenter = localStorage.getItem('SelectCostCenter');
    let selectCostCenter = JSON.parse(localSelectCostCenter);
    console.log("selectCostCenterkfeuhscdwuikilk", selectCostCenter)
    setName(selectCostCenter.name)
    setDescription(selectCostCenter.description)
    setCompanyId(selectCostCenter.company_id)
    setCompanyName(selectCostCenter.partner_name)
    setId(selectCostCenter.id)
  }

  const switchStep = () => {
    switch(step){
      case 1:
        return <Step1
          setStep={setStep}
          step={step}
          token={token}
          setName={setName}
          setEmail={setDescription}
          setCompany={setCompany}
          name={name}
          description={description}
          infoUser={infoUser}
          company={company}
          id={id}
          companyId={companyId}
          errorAlert={errorAlert}
          setErrorAlert={setErrorAlert}
          setErrorAlertMessage={setErrorAlertMessage}
        />
        break;
    }
  }

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink title={i18n.t("CostCenter")} link={'/cost-centers'} breadcrumbItem={i18n.t("CostCenterEdit")} />
          <Row>
            <Card>
              <CardBody>
                <Instructions step={step}></Instructions>
              </CardBody>
            </Card>
          </Row>
          <div className="container-fluid">
            <Row>
              <Card>{switchStep()}</Card>
              <AlertError
                showAlertError={errorAlert}
                setShowAlertError={setErrorAlert}
                textHeader={i18n.t("Error")}
                textBody={errorAlertMessage}
              />
            </Row>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default CreateEmployee;
